exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".UFVF86tHvvf6nZOhcyEbT {\n  padding: 2rem;\n}\n._3hGVbRMGMMBzzsmo_B7YT_,\n._2QnAdnzpgXAu3Z93QK1BXk {\n  display: flex;\n  flex-flow: row wrap;\n}\n._2QnAdnzpgXAu3Z93QK1BXk {\n  box-sizing: border-box;\n  max-width: 100%;\n}\n._3hGVbRMGMMBzzsmo_B7YT_ {\n  align-items: center;\n  align-content: flex-start;\n}\n._1NUNhV5wkkDrr2zn8XHYPT {\n  flex: 0 0 auto;\n  margin-right: 1rem;\n  margin-bottom: 1rem;\n}\n._2-BUPTBU22Y_Ouq9fPT2Qg {\n  color: #999;\n  flex: 1 1 auto;\n  font-size: 2rem;\n  line-height: 13rem;\n  text-align: center;\n}\n._2lUQdoJM5GefU8z8jJKr1i {\n  flex: 0 0 auto;\n  margin-right: 1rem;\n  margin-bottom: 1rem;\n}\n._2uVV_PoYCrXKkXVpVLyYkp {\n  margin-top: 0;\n  margin-bottom: 2rem;\n}\n", ""]);

// exports
exports.locals = {
	"game": "UFVF86tHvvf6nZOhcyEbT",
	"picked-cards": "_3hGVbRMGMMBzzsmo_B7YT_",
	"player-cards": "_2QnAdnzpgXAu3Z93QK1BXk",
	"card": "_1NUNhV5wkkDrr2zn8XHYPT",
	"payers-picking-cards": "_2-BUPTBU22Y_Ouq9fPT2Qg",
	"grouped-cards": "_2lUQdoJM5GefU8z8jJKr1i",
	"heading": "_2uVV_PoYCrXKkXVpVLyYkp"
};


/*****************
 ** WEBPACK FOOTER
 ** ./~/css-loader?modules!./~/stylus-loader!./src/css/game.styl
 ** module id = 273
 ** module chunks = 0
 **/